<template>
  <div
    class="grid grid-cols-2 divide-x items-center text-xs m-auto text-center border-t-white border-t mt-5"
  >
    <p class="text-white text-right px-3 py-3">
      © 2012–{{ currentYear }} Rally Navigator, LLC
    </p>
    <p class="text-[#FF0000] text-left px-3" @click="scrollToTop">
      <router-link class="inline-block py-3.5 px-1 hover:underline" to="/rally-maps"
        >Rally Route Planner</router-link
      >
      <span class="text-white px-1">·</span>
      <router-link class="inline-block py-3.5 px-1 hover:underline" to="/whats-new"
        >What's New</router-link
      >
      <span class="text-white px-1">·</span>
      <router-link
        class="inline-block py-3.5 px-1 hover:underline"
        to="/terms-of-use"
        >Terms of Use</router-link
      >
      <span class="text-white px-1">·</span>
      <router-link
        class="inline-block py-3.5 px-1 hover:underline"
        to="/privacy-policy"
        >Privacy Policy</router-link
      >
    </p>
  </div>
  <div
    v-if="$route.meta.alternates"
    class="text-xs text-center py-1 border-t-white border-t"
  >
    <span class="text-white px-1">Language:</span>
    <template v-for="(alt, i) in $route.meta.alternates" :key="alt.lang">
      <a
        :href="alt.path"
        class="text-[#FF0000] inline-block px-2 py-2 hover:underline"
        >{{ langName(alt.lang) }}</a
      >
      <span v-if="i < $route.meta.alternates.length - 1" class="text-white"
        >·</span
      >
    </template>
  </div>
</template>

<script>
const LANG_NAMES = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  nl: 'Nederlands',
  pl: 'Polski',
  cs: 'Čeština',
  fi: 'Suomi',
  el: 'Ελληνικά',
  hr: 'Hrvatski',
  ru: 'Русский',
  hi: 'हिन्दी',
  sv: 'Svenska',
  et: 'Eesti',
  hu: 'Magyar',
  tr: 'Türkçe',
  lv: 'Latviešu',
  ro: 'Română',
  ja: '日本語',
  bg: 'Български',
  ar: 'العربية',
  lt: 'Lietuvių',
  zh: '中文',
};

export default {
  name: 'FooterBar',
  computed: {
    // Derived so the footer never goes stale on 1 January.
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    langName(code) {
      return LANG_NAMES[code] || code;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
